var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"48","height":"48","rx":"24","fill":"#059669"}}),_c('path',{attrs:{"d":"M17 25L21 29L31 19","stroke":"#FFFFFF","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }